module.exports = __webpack_public_path__ + "img/logoutIcon.351a1a87.png";